export default __webpack_public_path__ + "static/media/about us page_Efficiency.685d306d.png";